module.exports = __webpack_public_path__ + "media/newstyle/images/icon-facebook-purple-b5d10d3bc5c5792634a1a7a7fc4cc69f.svg";